import React, { Component } from 'react';
import AccessContainer from '../../access/AccessContainer';
import { RootState } from '../../../redux/store';
import { changeConnection } from '../../../redux/actions/ConnectionActions';
import { connect } from 'react-redux';
import { ConnectedProps } from 'react-redux/es/exports';
import { AccessBase } from '../../../domain/access/BaseAccess';
import RoleHelper from '../../../RoleHelper';

class ConnectionAccessComponent extends Component<Props, State> {
  render() {
    const {
      connection: { connection },
    } = this.props;
    const access: AccessBase = { permission: connection.permission, collaborators: connection.collaborators };
    return (
      <div className={'flex w-full h-full'}>
        <AccessContainer access={access} changeAccess={this.changeAccess} disabled={!RoleHelper.canManage('Connection')} />
      </div>
    );
  }

  private changeAccess = (access: AccessBase) => {
    const {
      changeConnection,
      connection: { connection },
    } = this.props;
    connection.permission = access.permission;
    connection.collaborators = access.collaborators;
    changeConnection(connection);
  };
}

interface Props extends ReduxProps {}

class State {}

const mapStateToProps = (state: RootState) => ({
  connection: state.connection,
});
const mapDispatchToProps = { changeConnection };
const connector = connect(mapStateToProps, mapDispatchToProps);
type ReduxProps = ConnectedProps<typeof connector>;

export default connector(ConnectionAccessComponent);
